<template #content>
    

    <Toolbar class="mb-2 bg-gray-100">
        <template #start>
            <div class="flex items-center gap-1">
                <Button v-if="permissoes.CONTAS_INCLUIR" icon="pi pi-plus" label="Inserir por IA" severity="sucess"
                    size="small" @click="openCarneForm({contrato_id: contrato.id, contrato: contrato.id_primario})" />
            </div>
        </template>
        <template #end>
            <div class="flex items-center gap-1">
                <Button v-if="permissoes.CONTAS_INCLUIR" icon="pi pi-plus" label="Incluir" severity="info"
                                size="small" @click="openForm({contrato_id: contrato.id, id_primario: contrato.id_primario})" />
                <Button icon="pi pi-search" label="Buscar" severity="sucess" size="small" @click="toggleBusca" />
                <Button icon="pi pi-refresh" label="Atualizar" severity="warn" size="small" @click="loadData" />
            </div>
        </template>
    </Toolbar>

    <DataTable :value="lista" :loading="isLoading" size="small" stripedRows showGridlines scrollable
        scrollHeight="calc(100vh - 500px)" :sortField="params.sort.field" :sortOrder="params.sort.order"
        @sort="onTableSort">

        <Column style="width: 100px" field="id" header="#" sortable></Column>
        <Column field="valor" header="Valor" sortable>
            <template #body="{ data }">
                R$ {{ formatMoney(data.valor) }}
            </template>
        </Column>
        <Column field="data_mam" header="Data MAM" sortable>
            <template #body="{ data }">
                {{ dateFormat(data.data_mam) }}
                <template v-if="data.data_mam_dias > 0">
                    ({{data.data_mam_dias}} dias)
                </template>
            </template>
        </Column>
        <Column field="data_vencimento" header="Vencimento" sortable>
            <template #body="{ data }">
                {{ dateFormat(data.data_vencimento) }}
                <template v-if="data.data_vencimento_dias > 0">
                    ({{data.data_vencimento_dias}} dias)
                </template>
            </template>
        </Column>


        <Column style="width: 150px"
            bodyClass="flex justify-content-end gap-1">

            <template #body="{ data }">
                <Badge :value="data.boleto_id ? 'CB' : 'SB'" :severity="data.boleto_id ? 'success' : 'danger'" v-tooltip.top="data.boleto_id ? 'Com Boleto' : 'Sem Boleto'" >
                </Badge>
                <Badge :value="data.data_pagamento ? '$' : '$'" :severity="data.data_pagamento ? 'success' : 'danger'" v-tooltip.top="data.data_pagamento ? 'Pago' : 'Pendente'" >
                </Badge>
                <Button v-if="permissoes.CONTAS_EDITAR" icon="pi pi-pen-to-square" title="Atualizar" severity="info" size="small"
                    @click="openForm(data)" />
                <Button v-if="permissoes.CONTAS_REMOVER" icon="pi pi-trash" title="Remover" severity="danger" size="small"
                    @click="remove(data)" />
            </template>
        </Column>

        <template #empty>
            <div class="text-center text-gray-600">
                Nenhum registro encontrado
            </div>
        </template>
    </DataTable>

    <div class="flex justify-content-between flex-wrap">
        <div class="flex align-items-center justify-content-center">
            <div class="flex justify-end mt-2 text-sm text-gray-600">
                <span>{{ pagination.total }} registros</span>
            </div>

        </div>
        <div class="flex align-items-center justify-content-center">
            <Paginator :first="pagination.first" :rows="pagination.perPage" :totalRecords="pagination.total"
                @page="onPage">
            </Paginator>
        </div>
        <div class="flex align-items-center justify-content-center">
        </div>
    </div>

    <Popover ref="busca" :closeOnEscape="false" :dismissable="false" class="w-3">
        <div class="w-full">
            <form @submit.prevent="onSubmitBusca">
                <div class="w-full">
                    <div class="field mt-4">
                        <FloatLabel>
                            <InputText v-model="params.filter['contrato']" class="w-full" />
                            <label>Id Primário e Secundário</label>
                        </FloatLabel>
                    </div>

                    <div class="field mt-4">
                        <FloatLabel>
                            <InputText v-model="params.filter['site']" class="w-full" />
                            <label>Site/Localidade</label>
                        </FloatLabel>
                    </div>

                    <div class="field mt-4">
                        <FloatLabel>
                            <InputText id="codigo_de_barras" v-model="params.filter.codigo_de_barras" class="w-full" />
                            <label for="codigo_de_barras">Código de Barras</label>
                        </FloatLabel>
                    </div>
                </div>

                <div class="flex justify-content-end gap-1">
                    <Button type="submit" label="Buscar" severity="success" icon="pi pi-search"
                        class="flex align-items-center justify-content-center" />
                    <Button icon="pi pi-eraser" label="Limpar" severity="warn" size="small"
                        class="flex align-items-center justify-content-center" @click="onClearBusca" />
                    <Button icon="pi pi-times" label="Fechar" severity="danger" size="small"
                        class="flex align-items-center justify-content-center" @click="toggleBusca" />
                </div>
            </form>
        </div>
    </Popover>

    <ContaForm :visible="visibleForm" :data="item" @close="closeForm" @save="loadData" />
    <CarneForm :visible="visibleCarneForm" :data="item" @close="closeForm" @save="loadData" />

</template>
<script>
import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Badge from 'primevue/badge';

import Select from 'primevue/select';
import InputMask from 'primevue/inputmask';
import Checkbox from 'primevue/checkbox';
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button';
import ScrollPanel from 'primevue/scrollpanel';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';

import DataTable from 'primevue/datatable';
import Toolbar from 'primevue/toolbar';
import Paginator from 'primevue/paginator';
import Column from 'primevue/column';

import Popover from 'primevue/popover';

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import ContaForm from '@/page/conta/Form.vue';
import CarneForm from '@/page/conta/CarneForm.vue';

import Conta from '@/service/conta.js';

import Filter from '@/utils/Filter.js';

import Mask from '@/utils/Mask.js';
import Moment from 'moment';

export default {
    components: {
        Dialog,
        FloatLabel,
        Button,
        InputText,
        DataTable,
        Paginator,
        Column,
        InputMask,
        Select,
        AutoComplete,
        Checkbox,
        ScrollPanel,
        Tabs,
        TabList,
        Tab,
        TabPanels,
        TabPanel,
        InputGroup,
        InputGroupAddon,
        Toolbar,
        Badge,
        Popover,

        // Form
        ContaForm,
        CarneForm,
    },
    props: {
        contrato: {},
        permissoes: {},
    },
    emits: ['onOpenContaForm'],
    data() {
        return {
            isLoading: false,

            tabIndex: 0,

            item: {},
            visibleForm: false,
            visibleCarneForm: false,

            lista: [],
            params: {
                filter: {},
                sort: {
                    field: 'id',
                    order: 1
                }
            },
            pagination: {
                page: 0,
                perPage: 0,
                total: 0,
            },
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        openContaForm(item) {
            this.item = { ...item };
            this.visibleForm = true;
        },
        openCarneForm(item) {
            this.item = { ...item };
            this.visibleCarneForm = true;
        },
        closeForm(event) {
            this.item = {};
            this.visibleForm = false;
            this.visibleCarneForm = false;
        },

        openForm(conta) {
            this.$emit("onOpenContaForm", conta);
        },
        // Paginate
        onPage(event) {
            const page = event ? event.page : 0;
            this.pagination.page = page;
            this.$router.replace({ name: this.$route.name, query: { page: page } });
            this.loadData();
        },

        // Filter
        toggleBusca(event) {
            this.$refs.busca.toggle(event);
        },
        onClearBusca(event) {
            this.toggleBusca(event);
            this.params.filter = {};
            this.onPage();
        },
        onSubmitBusca(event) {
            this.toggleBusca(event);
            this.onPage();
        },

        loadDataParams() {
            let params = [`filter[cont.contrato_id]=${this.contrato.id}`];

            // Pagination
            params.push(`page=${1 + this.pagination.page}`);

            // Filter
            params = Filter.formToQuery(this.params.filter, params);

            // Order
            if(['id'].indexOf(this.params.sort.field)>= 0){
                params.push(`order[cont.${this.params.sort.field}]=` + (this.params.sort.order > 0 ? 'asc' : 'desc'));
            }
            else{
                params.push(`order[${this.params.sort.field}]=` + (this.params.sort.order > 0 ? 'asc' : 'desc'));
            }
            return params;
        },
        onTableSort(event) {
            this.params.sort = {
                field: event.sortField,
                order: event.sortOrder,
            };
            this.loadData();
        },
        loadData() {
            let params = this.loadDataParams();

            this.isLoading = true;
            Conta.list(params.join("&"))
                .then(response => {
                    this.lista = response.data.data;
                    this.pagination.perPage = response.data.per_page;
                    this.pagination.total = response.data.total;
                    this.pagination.first = response.data.per_page * this.pagination.page;
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        formatMoney(valor) {
            if (!valor) return Mask.money(0);
            return Mask.money(valor);
        },
        dateFormat(value) {
            if (!value) return;
            return Moment(value).format("DD/MM/YYYY");
        },
        remove(data) {
            this.$confirm.require({
                message: 'Deseja realmente remover o item?',
                header: 'Remover',
                acceptLabel: 'Remover',
                icon: 'pi pi-trash',
                acceptClass: 'bg-red-500 text-white border-red-500',
                rejectLabel: 'Cancelar',
                rejectClass: 'bg-red-400 text-white',
                accept: () => {
                    this.isLoading = true;
                    Conta.delete(data.id)
                        .then(response => {
                            this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'O item foi removido com sucesso.', life: 3000 });
                            this.loadData();
                        })
                        .catch(error => {
                            if (error.response) {
                                let err = error.response.data;
                                if (err.erros) {
                                    for (let i in err.erros) {
                                        this.errors[i] = err.erros[i][0];
                                    }
                                    return;
                                }
                                if (error.response.data.msg) {
                                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                                    return;
                                }
                            }
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                },
            });
        },
    }
}
</script>
